import React from "react";
import Typography from "@/components/shared/Typography";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CardDescriptionProps } from "../types";

function CardDescription({ className, ...props }: CardDescriptionProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Typography.P
      data-slot="card-description"
      className={cn(
        "text-sm text-muted-foreground font-lora",
        className,
        classes,
      )}
      {...native}
    />
  );
}

CardDescription.displayName = "Card.Description";

export default CardDescription;
